module.exports = __webpack_public_path__ + "img/Graph-2.4d3e32d4.svg";